export default __webpack_public_path__ + "static/media/shipping_management_orange.1be41ee9.svg";